module.exports = __webpack_public_path__ + "static/media/slider-design-studio-slide-01-bg.ee554567.jpg";